import React from 'react';

/**
 * Renders an order's progress via the `.timeline` primitive. `events` is the array returned by
 * GET /api/v1/customer-profile/orders/:orderId/timeline (backend/src/services/order-timeline.service.ts)
 * — already ordered chronologically, so all but the last are "complete" and the last is "current".
 */
export default function StatusTimeline({ events }) {
  if (!events || events.length === 0) {
    return <p style={{ color: 'var(--text-light)', fontSize: '0.9rem' }}>No status updates yet.</p>;
  }

  return (
    <div className="timeline">
      {events.map((event, i) => {
        const isLast = i === events.length - 1;
        return (
          <div key={`${event.at}-${event.label}`} className={`timeline-step${isLast ? ' is-current' : ' is-complete'}`}>
            <div className="timeline-node">{isLast ? i + 1 : '✓'}</div>
            <div className="timeline-label">{event.label}</div>
          </div>
        );
      })}
    </div>
  );
}
